module.exports = __webpack_public_path__ + "ae24ad8e2789eb9b7b45b3d70109a637.png";